// @ts-nocheck
import React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import { deepOrange, deepPurple } from '@mui/material/colors';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { useBody } from '../Body/state/BodyContext';
import Skeleton from '@mui/material/Skeleton';
import SinapThemev2 from "../styles/SinapThemev2";

// Define styled components
const RootStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    '& > *': {
        margin: "8px",
    },
    '&:hover': {
        transform: `scale(1.1,1.1)`,
        transition: `transform 150ms`,
    },
}));

const AvatarStyled = styled(Avatar, {
    shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open }) => ({
    width: open ? 87 : 50,
    height: open ? 83 : 50,
    fontSize: "2em",
    border: `2px solid ${SinapThemev2.palette.primary.main}`,
    fontFamily: open ? 'Roboto' : undefined,
    transition: '0.5s',
    '&:hover': {
        cursor: 'pointer',
    },
}));

export default function LetterAvatar(props) {
    const { letter, toggleOpen, visibilityMenu } = props;
    const { googleImageBase64 } = useBody();

    return (
        <RootStyled id="img-contenedor">
            <List>
                <ListItem sx={{ paddingBottom: '0px' }}>
                    {googleImageBase64 !== null ? (
                        <AvatarStyled
                            src={`data:image/;base64, ${googleImageBase64}`}
                            open={visibilityMenu}
                            onClick={toggleOpen}
                        />
                    ) : (
                        <Skeleton variant="circular">
                            <AvatarStyled open={false} />
                        </Skeleton>
                    )}
                </ListItem>
            </List>
        </RootStyled>
    );
}
